export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  autoTypeID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  brandID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/automodel/automodel-form.js